import {
  Field,
  StringField,
} from '../../util/components/resource/resource-fields/resource-fields';
import { ApiResource } from '../api-resource';
import { Endpoint } from '../api.decorators';
import { PaymentHistory } from '../payment/payment-history.model';
import { Staff } from '../staff/staff.model';

@Endpoint('organizations', 'Organization')
export class Organization extends ApiResource<Organization> {
  @StringField({ label: $localize`Name` })
  name!: string;

  @StringField({ label: $localize`Email` })
  email!: string;

  @StringField({ label: $localize`Phone number` })
  phoneNumber!: string;

  @StringField({ label: $localize`Address` })
  address!: string;

  @StringField({ label: $localize`Postal code` })
  zipCode!: string;

  @StringField({ label: $localize`City` })
  city!: string;

  @StringField({ label: $localize`Country` })
  country!: string;

  @StringField({ label: $localize`Tax code` })
  taxCode!: string;

  @StringField({ label: $localize`Contact person` })
  billingContactPerson!: string;

  @StringField({ label: $localize`Address line 1` })
  billingAddressLine1!: string;

  @StringField({ label: $localize`Address line 2` })
  billingAddressLine2!: string;

  @StringField({ label: $localize`Billing email` })
  billingEmail!: string;

  @StringField({ label: $localize`Bank account` })
  bankAccountNumber!: string;

  @Field({
    default: () => false,
    label: $localize`Peppol`,
  })
  billingPeppol!: boolean;

  @Field({
    type: () => Location,
    label: $localize`Location`,
  })
  locations?: Location[];

  @Field({ readonly: true, includeFilter: false })
  paymentHistory!: PaymentHistory;

  @Field({ type: () => Staff, label: $localize`Members` })
  members!: Staff[];

  override toLabel(): string {
    return this.name;
  }
}
